const MusicActionTypes = {
    FETCH_MUSIC_START: 'FETCH_MUSIC_START',
    FETCH_MUSIC_SUCCESS: 'FETCH_MUSIC_SUCCESS',
    FETCH_MUSIC_FAILURE: 'FETCH_MUSIC_FAILURE',
	PLAY_MUSIC: "PLAY_MUSIC", 
	RESET_TRIGGER: "RESET_TRIGGER",
};

export default MusicActionTypes;

